import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'src/utils/store'
import { actions } from '../../TransfersState'
import { CircularProgress, Typography } from '@mui/material'
import { TransfersConfigsEnum, TransferCageStatusEnum } from '../../TransfersTypes'
import * as S from './WaitingInfo.styles'
import { useFulfillmentCenter } from 'src/hooks/useFulfillmentCenter'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'

const WaitingInfo = () => {
  const { receiveUser, receiveData } = useSelector((state) => state.transfers)

  const processingStatus = [
    TransferCageStatusEnum.PROCESSING_RESERVE_CONFIRMATION,
    TransferCageStatusEnum.PROCESSING_MAIN_STOCK_ENTRY,
    TransferCageStatusEnum.PROCESSING_PURCHASE_INTEGRATION,
    TransferCageStatusEnum.PROCESSING_FINANCES_INTEGRATION,
    TransferCageStatusEnum.PROCESSING_OPERATIONAL_STOCK_ENTRY,
  ]

  const failedStatus = [
    TransferCageStatusEnum.FAILED_RESERVE_CONFIRMATION,
    TransferCageStatusEnum.FAILED_MAIN_STOCK_ENTRY,
    TransferCageStatusEnum.FAILED_PURCHASE_INTEGRATION,
    TransferCageStatusEnum.FAILED_FINANCES_INTEGRATION,
    TransferCageStatusEnum.FAILED_OPERATIONAL_STOCK_ENTRY,
  ]

  const dispatch = useDispatch()
  const history = useHistory()

  const [preventDoubleClick, setPreventDoubleClick] = useState(false)

  const { fc } = useFulfillmentCenter()

  const tryAgain = () => {
    if (preventDoubleClick || !receiveUser || !receiveData) {
      return
    }

    setPreventDoubleClick(true)

    dispatch(actions.receiveStart({
      badge: receiveUser.badge,
      idFulfillmentCenter: fc.id,
      cageAddress: receiveData.cageAddress,
      invoiceAccessKey: receiveData.invoiceAccessKey,
      history,
      onFinish: () => setPreventDoubleClick(false),
      inWaitingPage: true,
    }))
  }

  useEffect(() => {
    let timeout: NodeJS.Timeout | null = null

    if (receiveUser && receiveData) {
      if (processingStatus.includes(receiveData.idStatus)) {
        timeout = setTimeout(() => {
          dispatch(actions.getReceiveStatus({
            badge: receiveUser.badge,
            idCage: receiveData.idCage,
          }))
        }, TransfersConfigsEnum.RECEIVE_WAITING_SCREEN_UPDATE_RATE_MS)
      } else if (receiveData.idStatus === TransferCageStatusEnum.INTEGRATED_SUCCESSFULLY) {
        setPreventDoubleClick(true)
        dispatch(actions.receiveStart({
          badge: receiveUser.badge,
          idFulfillmentCenter: fc.id,
          cageAddress: receiveData.cageAddress,
          invoiceAccessKey: receiveData.invoiceAccessKey,
          history,
          onFinish: () => setPreventDoubleClick(false),
          inWaitingPage: true,
        }))
      } else if (receiveData.idStatus === TransferCageStatusEnum.FINISHED) {
        toast.info('Recebimento de transferência está finalizado!')
        dispatch(actions.clearState())
      }
    }

    return () => {
      if (timeout) clearTimeout(timeout)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, receiveUser, receiveData, receiveData?.idStatus])

  return (
    <S.Container>
      {receiveData && processingStatus.includes(receiveData.idStatus) && (
        <>
          <Typography fontWeight='bold' fontSize='18px' textAlign='center'>{receiveData.status}...</Typography>
          <CircularProgress size={40} data-testid='circular-progress-test-id' />
        </>
      )}
      {receiveData && (failedStatus.includes(receiveData.idStatus) || receiveData.idStatus === TransferCageStatusEnum.INTEGRATED_SUCCESSFULLY) && (
        <>
          <Typography fontWeight='bold' fontSize='18px' textAlign='center'>{receiveData.status}</Typography>
          <S.CustomButton
            title='Tentar novamente'
            type='button'
            bgColor='blue'
            hoverColor='darkBlueHover'
            letterColor='white'
            data-testid='try-again-button-test-id'
            fullWidth
            onClick={tryAgain}
            disabled={preventDoubleClick || !receiveUser || !receiveData}
          />
        </>
      )}
    </S.Container>
  )
}

export default WaitingInfo
